<!--设备管理弹窗-->
<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="show"
    width="780px"
    append-to-body
    class="dialogStyle"
  >
    <div style="padding: 15px 0;width: 100%">
      <el-form
        :model="form"
        label-width="100px"
        :rules="rules"
        ref="assetFormD"
      >
        <!--设备信息-->
        <div v-if="!isEdit" style="position:relative">
          <bigScreenTitleBorder :title="'设备信息'"></bigScreenTitleBorder>
          <div class="form_collapse" @click="isShowAsset = !isShowAsset">
            {{ isShowAsset ? "关闭" : "展开"
            }}<i
              :class="isShowAsset ? `el-icon-arrow-up` : `el-icon-arrow-down`"
            ></i>
          </div>
          <div v-if="isShowAsset">
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备名称:">
                  {{ form.name }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备类型:">
                  {{ form.type == "1" ? "DVR" : "IPC" }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备厂商:">
                  {{ form.manufacturer }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备序列号:">
                  {{ form.snNumber }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="IP地址:">
                  {{ form.deviceIp }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="视频通道:">
                  {{ form.sptd }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备状态:">
                  {{ form.status == 0 ? "离线" : "在线" }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--安装信息-->
        <div style="position:relative">
          <bigScreenTitleBorder :title="'安装信息'"></bigScreenTitleBorder>
          <div class="form_collapse" @click="isShowInstall = !isShowInstall">
            {{ isShowInstall ? "关闭" : "展开"
            }}<i
              :class="isShowInstall ? `el-icon-arrow-up` : `el-icon-arrow-down`"
            ></i>
          </div>
          <div v-if="isShowInstall">
            <el-row style="margin-top:10px">
              <el-form-item label="安装位置">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="经度" prop="lon">
                      <el-input
                        class="textInput"
                        v-model="form.lon"
                        placeholder="请输入经度"
                        oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,9})?.*$/,'$1')"
                        :disabled="!isEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="纬度" prop="lat">
                      <el-input
                        class="textInput"
                        v-model="form.lat"
                        placeholder="请输入纬度"
                        oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,9})?.*$/,'$1')"
                        :disabled="!isEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                    <el-form-item prop="qhdm">
                      <el-cascader
                        style="height: 40px"
                        class="textInput"
                        @change="liandong"
                        :options="areaOptions"
                        :props="areaProps"
                        :show-all-levels="false"
                        :disabled="!isEdit"
                        v-model="form.qhdm"
                        :placeholder="form.qhmc"
                        ref="asset_qh"
                      >
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-row>

            <el-form-item label="所属组织">
              <div style="margin-left:60px">
                <el-radio-group v-model="form.zz" disabled>
                  <el-radio :label="1">门店</el-radio>
                  <el-radio :label="2">仓库</el-radio>
                </el-radio-group>
                <div>{{ form.enterpriseName }}</div>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <div
        style="width: 100%;display: flex;justify-content: flex-end"
        v-if="title == '编辑'"
      >
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import bigScreenTitleBorder from "@/components/headerTitle/bigScreenTitleBorder.vue";
import API_dic from "@/api/api_common";
import Cookies from "js-cookie";
import API from "../../../../../api/api_asset/api_asset";
export default {
  components: { bigScreenTitleBorder },
  data() {
    const validateId = (rule, value, callback) => {
      if (!this.qhdm) {
        callback(new Error("请选择区划"));
      } else callback();
    };
    const latRule = (rule, value, callback) => {
      if (value > 90 || value < -90) {
        callback(new Error("请输入合适的纬度"));
      } else callback();
    };
    const lonRule = (rule, value, callback) => {
      if (value > 180 || value < -180) {
        callback(new Error("请输入合适的经度"));
      } else callback();
    };
    return {
      title: "",
      isShowInstall: true,
      isShowAsset: true,
      isEdit: false,
      show: false,
      form: { lat: "", lon: "", qhdm: "", qhmc: "" },
      rules: {
        lon: [
          { required: true, message: "请输入经度", trigger: "blur" },
          { validator: lonRule, trigger: "blur" }
        ],
        lat: [
          { required: true, message: "请输入纬度", trigger: "blur" },
          { validator: latRule, trigger: "blur" }
        ],
        qhdm: [{ required: true, validator: validateId, trigger: "change" }]
      },
      areaCode: Cookies.get("curAreaCode"),
      areaName: Cookies.get("curAreaName"),
      qhdm: Cookies.get("curAreaCode"),
      areaOptions: [],
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        // children: "children",
        expandTrigger: "hover",
        // emitPath: false,
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          let qhdm;
          if (node.root) {
            qhdm = Cookies.get("curAreaCode");
          } else {
            qhdm = node.value;
          }
          if (qhdm.length == 9) {
            resolve([]);
            return;
          }
          API_dic.getAreaDrillDown({ qhdm: qhdm }).then(res => {
            if (res.code == 200 && res.data && res.data.length > 0) {
              let nodes = [];
              res.data.forEach(item => {
                /*通过leaf使乡镇不在有展开符号，限制到最低为乡镇级别*/
                if (qhdm.length >= 6) {
                  nodes.push({
                    qhdm: item.qhdm,
                    qhmc: item.qhmc,
                    leaf: true
                  });
                } else {
                  nodes.push({
                    qhdm: item.qhdm,
                    qhmc: item.qhmc,
                    leaf: false
                  });
                }
              });

              resolve(nodes);
            } else {
              resolve([]);
            }
          });
        }
      }
    };
  },
  methods: {
    init(row, val) {
      this.isEdit = val;
      this.title = val ? "编辑" : "详情";
      this.isShowAsset = !val;
      this.show = true;
      this.areaOptions = [
        {
          qhdm: this.areaCode,
          qhmc: this.areaName,
          children: null,
          leaf: this.areaCode.length >= 9
        }
      ];
      row.zz = row.ckmc ? 2 : 1;
      row.sptd = row.unitsObj
        ? row.unitsObj[0].channels
          ? row.unitsObj[0].channels[0].channelName
          : "-"
        : "-";
      row.qhdms = [row.qhdm];
      this.form = { ...row };
    },
    async submitForm() {
      this.$refs.assetFormD.validate(async valid => {
        if (valid) {
          let params = {
            lon: this.form.lon,
            lat: this.form.lat,
            qhdm: this.form.qhdm,
            qhmc: this.form.qhmc,
            deviceId: this.form.code
          };
          let res = await API.updateDevice(params);
          if (res.code == 200) {
            this.GLOBAL.common_tool.success("编辑成功");
            this.show = false;
            this.$emit("onClose");
          } else {
            this.GLOBAL.common_tool.warning(res.msg || "编辑失败");
            this.GLOBAL.common_tool.sys_reason_log(res.msg + "_" + "编辑失败");
          }
        }
      });
    },
    cancel() {
      this.show = false;
    },
    liandong: function(obj) {
      if (obj.length > 0) {
        this.form.qhdm = obj[obj.length - 1];
        // this.filterForm.qhdmValue = obj[obj.length - 1];
      } else {
        this.form.qhdm = this.areaCode;
      }
      this.form.qhmc = this.$refs["asset_qh"].getCheckedNodes()[0].data.qhmc;
    }
  }
};
</script>
<style lang="less" scoped>
.form_collapse {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/detailDialog.vue